<template>
  <div class="section-category section-full">
    <div class="content-centered">
      <h2 class="ttl2 popup-header" v-translate>Do Payment</h2>
      <div class="inner-do-payment" v-if="!isConfirmModal">
        <div class="btns-footer mt-0 mb-4">
          <button class="btn" :class="payment.type === 0 ? 'btn-confirm' : 'btn-cancel'" @click="toggleType(0)" v-translate>Money-in</button>
          <button class="btn" :class="payment.type === 1 ? 'btn-confirm' : 'btn-cancel'" @click="toggleType(1)" v-translate>Money-out</button>
        </div>
        <div class="wrap-grid-payment payment-grid">
          <grid-view :items="expenses" :highlight="true" @pickItem="pickExpense"></grid-view>
        </div>
        <div class="form-content-inline">
          <div class="row">
            <div class="col-sm-6 form-group">
              <label style="width: 80px">
                <translate>Amount</translate>({{ getMap('currency').symbol }})
              </label>
              <input-pad
                :item="payment"
                :property="'amount'"
                :maxLength="10"
                :attributes="{class: 'form-control form-control-amount'}" />
            </div>
            <div class="col-sm-6 form-group">
              <label v-translate style="width: 80px">Note</label>
              <input class="form-control form-control-note" v-model="payment.note">
            </div>
          </div>
        </div>
        <div class="btns-footer">
          <button class="btn btn-confirm" @click="handleOk" v-translate>Ok</button>
        </div>
      </div>
      <!-- /.inner-do-payment -->
      <div class="confirm-modal" v-else>
        <div class="confirm-content-do-payment">
          <div class="text-center">
            <table class="table-boderless text-left">
              <tr>
                <th><translate>Amount</translate> {{ payment.type ? $gettext('out') : $gettext('in') }}</th>
                <td><big class="value-amount-in">{{ payment.amount | currency }}</big></td>
              </tr>
              <tr>
                <th v-translate>Expense categories</th>
                <td>{{ expenseCategoryName }}</td>
              </tr>
              <tr>
                <th v-translate>Note</th>
                <td>{{ payment.note }}</td>
              </tr>
            </table>
            <div class="btns-footer">
              <button class="btn btn-confirm" @click="onConfirm" v-translate>Confirm</button>
              <button class="btn btn-cancel" @click="onCancel" v-translate>Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.confirm-modal -->
    </div>
  </div>
</template>

<script>
import GridView from '@/components/GridView.vue';
import PaymentService from '@/services/PaymentService';
import { SET_MESSAGE_MODAL } from '@/store/mutation-types';

export default {
  name: 'DoPayment',
  components: {
    GridView,
  },
  data() {
    return {
      isConfirmModal: false,
      isLoading: false,
      expenseCategoryName: '',
      payment: {
        type: null,
        amount: '',
        note: '',
        expenseCategory: null,
      },
    };
  },
  computed: {
    expenses() {
      return this.getArray('expense_categories').filter(expense => {
        return !expense.type || expense.type != 'system';
      }).map(expense => {
        expense.name = expense.preset;
        return expense;
      });
    },
  },
  methods: {
    pickExpense(expense) {
      this.payment.expenseCategory = expense.id;
      this.expenseCategoryName = expense.name;
    },
    toggleType(type) {
      this.payment.type = type;
    },
    handleOk() {
      const { amount, expenseCategory, type } = this.payment;
      if (amount && expenseCategory && type !== null) {
        this.isConfirmModal = true;
      } else {
        if(!type) {
          this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Please select payment type (money-in / money-out)'));
        } else {
          this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Please select expense category and input amount'));
        }
      }
    },
    async onConfirm() {
      this.isLoading = true;
      const response = await PaymentService.new(this.payment);
      if (response) {
        await this.$store.dispatch('print', { billData: response, printProductTicket: false });
        this.payment = {
          type: null,
          amount: '',
          note: '',
          expenseCategory: null,
        };
        this.isConfirmModal = false;
      }
      this.isLoading = false;
    },
    onCancel() {
      if(this.isLoading) return;
      this.isConfirmModal = false;
    },
  },

};
</script>
